import dayjs from 'dayjs'

/**
 * 拼接路径
 * @param args
 * @returns
 */
export const joinpath = (...args: string[]) => {
  const strs = args.map((u: string) => u.replace(/^\/+|\/+$/g, ''))

  const _url = strs.join('/')
  if (!_url.startsWith('/')) {
    return '/' + _url
  }

  return _url
}

/**
 * 文件大小格式化
 * @param size
 */
export const sizeFormat = (size: string | number): string => {
  if (!size) return "0 K"

  const _size = parseInt(size + '')

  if (_size >= 1073741824) {
    return `${(_size / 1073741824).toFixed(2)} G`
  } else if (_size < 1073741824 && _size >= 1048576) {
    return `${(_size / 1048576).toFixed(2)} M`
  } else {
    return `${(_size / 1024).toFixed(0)} K`
  }
}

/**
 * 格式化时间
 * @param value
 * @param format
 * @returns
 */
export const dateFormat = (value: any, format = 'YYYY-MM-DD HH:mm:ss'): string => {
  if (!value) return '--'
  return dayjs(value || new Date()).format(format)
}
